import React from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';

const ClearIconComponent =
    (handleClear: () => void, isVisible: boolean) => () =>
        isVisible ? (
            <IconButton onClick={handleClear} size="small" sx={{ mr: 1 }}>
                <ClearIcon />
            </IconButton>
        ) : (
            <></>
        );

export default ClearIconComponent;
